import { Area, AreaChart, ResponsiveContainer } from "recharts";

// Tiny line/area chart with no axes — meant to sit inside a KPI tile.
// Pass numeric values directly; we wrap them into `{v}` rows for Recharts.

export default function Sparkline({
  values,
  positive,
  height = 36,
}: {
  values: number[];
  positive?: boolean; // if explicitly set, colors the line; otherwise auto-detect
  height?: number;
}) {
  if (values.length === 0) {
    return <div style={{ height }} />;
  }
  const data = values.map((v, i) => ({ i, v }));
  const auto = positive ?? values[values.length - 1]! >= values[0]!;
  const stroke = auto ? "#10b981" : "#f43f5e";
  const fill = auto ? "rgba(16, 185, 129, 0.18)" : "rgba(244, 63, 94, 0.18)";
  const id = `spark-${Math.random().toString(36).slice(2, 8)}`;
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <defs>
            <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={stroke} stopOpacity={0.35} />
              <stop offset="100%" stopColor={stroke} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="v"
            stroke={stroke}
            strokeWidth={1.5}
            fill={`url(#${id})`}
            isAnimationActive={false}
            // Hide the area's bottom line to keep things tidy.
            dot={false}
            activeDot={false}
            // Suppress recharts default legend / cursor / tooltip.
          />
          <defs>
            <pattern id="spark-bg" patternUnits="userSpaceOnUse" width="100" height="100">
              <rect width="100" height="100" fill={fill} opacity="0" />
            </pattern>
          </defs>
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
